module.exports = __webpack_public_path__ + "img/save.f2e50b49.jpg";